import { dateUtils, type Optional } from '@festina-life/core'
import dayjs from 'dayjs'

export type TradeCycleFilterFormValues = {
  fromDate: string
  toDate: string
}

export const getDefaultTradeCycleFilterValues = (
  time: Optional<Date | string>,
): TradeCycleFilterFormValues => ({
  fromDate: dateUtils.dateAsServerStr(dayjs(time).subtract(30, 'day').toDate()),
  toDate: dateUtils.dateAsServerStr(dayjs(time).toDate()),
})

export const tradeCycleFilterValuesToParams = ({
  fromDate,
  toDate,
}: TradeCycleFilterFormValues) => ({
  // fromDate/toDate may be stripped by FormikForm sanitization when cleared, and dayjs(undefined) would resolve to now.
  fromTime: fromDate
    ? dateUtils.dateAsDateTimeStr(dayjs(fromDate).startOf('day').toDate())
    : undefined,
  toTime: toDate
    ? dateUtils.dateAsDateTimeStr(dayjs(toDate).startOf('day').toDate())
    : undefined,
})
